module.exports = __webpack_public_path__ + "static/media/icone-ola-onibus-preto.f529e2d5.svg";